import { render } from "./GeneralInfoTable.vue?vue&type=template&id=23b9f4c4&ts=true"
import script from "./GeneralInfoTable.vue?vue&type=script&lang=ts"
export * from "./GeneralInfoTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__